
import * as Yup from "yup";
const contactUsValidationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    shortDetails: Yup.string().required("Short details are required"),
    address: Yup.string().required("Address is required"),
    emailAddress: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    contactNumber: Yup.string().required("Contact number is required"),
  });

export default contactUsValidationSchema;
